import { Injectable } from '@angular/core';
import { Actions, Effect } from '@ngrx/effects';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/withLatestFrom';
import { HttpClient, HttpRequest } from '@angular/common/http';
import { Store } from '@ngrx/store';

import * as ReportActions from '../store/report.actions';
import { ChartInfo } from '../chart-info.model';
import * as fromReport from '../store/report.reducers';

@Injectable()
export class ReportEffects {
  @Effect()
  eventFetch = this.actions$
    .ofType(ReportActions.FETCH_CHARTS)
    .switchMap((action: ReportActions.FetchCharts) => {
      return this.httpClient.get<ChartInfo[]>('https://eventapp-c6bd6.firebaseio.com' + '/' + 'event_organizers/' +
      firebase.auth().currentUser.uid + '.json', {
        observe: 'body',
        responseType: 'json'
      })
    })
    .map(
      (events) => {
        console.log(events);
        // tslint:disable-next-line:prefer-const
        for (let event of events) {
          if (!event['questions']) {
            event['questions'] = [];
          }
        }
        return {
          type: ReportActions.SET_CHARTS,
          payload: events
        };
      }
    );

  constructor(private actions$: Actions,
              private httpClient: HttpClient,
              private store: Store<fromReport.State>) {}
}



// WEBPACK FOOTER //
// ./src/app/report/store/report.effects.ts